export const CHAT_SEND = 'CHAT_SEND'


export function chatSend(trip_id, message, sender_user_id, hashtag, mentions, created_at) {	
    return {
        type: CHAT_SEND,
        trip_id,
        message,
        sender_user_id,
        hashtag,
        mentions,
        created_at
    }
}
